import { useState } from 'react'
import { useFormFactor } from '../../../hooks'

// MT.3 brand refresh: descriptions are always visible on cards — no hover
// reveal. `expanded` therefore starts true and stays true; the hover
// handlers only drive `hoverShadow`, which lifts the card with a
// drop-shadow on desktop. `handleToggleDescription` is kept so the mobile
// ToggleDescriptionButton can still collapse the subtitle when there
// isn't a hover gesture.
const useCardExpand = () => {
  const [expanded, setExpanded] = useState(true)
  const [hoverShadow, setHoverShadow] = useState(false)
  const { isDesktop } = useFormFactor()

  const handleToggleDescription = () => setExpanded(!expanded)
  const handleMouseEnter = () => isDesktop && setHoverShadow(true)
  const handleMouseLeave = () => isDesktop && setHoverShadow(false)

  return {
    expanded,
    hoverShadow,
    handleToggleDescription,
    handleMouseEnter,
    handleMouseLeave
  }
}

export default useCardExpand
